import React, { useState } from "react";
import axios from "axios";

import SearchForm from "./SearchForm";
import StatusAlerts from "./StatusAlert";
import MembersTable from "./MembersTable";

const EkycVerification = ({ heading }) => {
  const [members, setMembers] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [statusColor, setStatusColor] = useState("info");

  const handleSearch = async (searchType, searchValue) => {
    setError("");
    setMembers(null);
    setStatusMessage("");

    if (!searchValue.trim()) {
      setError("Please enter a value to search.");
      return;
    }
    setLoading(true);

    const BASE_URL = process.env.REACT_APP_URL_SIDE;
    let url = "";
    if (searchType === "aadhaar") {
      url = `${BASE_URL}/api/ekyc/status/by-aadhaar/${searchValue}`;
    } else if (searchType === "rc") {
      url = `${BASE_URL}/api/ekyc/status/by-rc/${searchValue}`;
    } else {
      url = `${BASE_URL}/api/ekyc/status/by-application/${searchValue}`;
    }

    try {
      const response = await axios.get(url);
      const result = response.data;
      setStatusMessage(result.statusMessage);
      const alertColor =
        result.statusColor === "green"
          ? "success"
          : result.statusColor === "red"
          ? "error"
          : "warning";
      setStatusColor(alertColor);
      setMembers(result.members || []);
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || "Failed to fetch details.";
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const appMembers = members ? members.filter(m => m.sourceTable === 'Application') : [];
  const eposMembers = members ? members.filter(m => m.sourceTable === 'ePOS') : [];
  
  const showTwoTables = appMembers.length > 0 && eposMembers.length > 0;

  return (
    <div className="lg:p-6 my-5 mx-auto max-w-[90vw] rounded-xl">
      <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">
        {heading || "e-KYC Verification Status"}
      </h2>

      <SearchForm onSearch={handleSearch} loading={loading} />

      <StatusAlerts
        error={error}
        statusMessage={statusMessage}
        statusColor={statusColor}
      />
      {members && members.length > 0 && (
        showTwoTables ? (
          <div className="mt-8 space-y-8">
            <div>
              <h3 className="text-xl font-semibold mb-2 text-gray-700">
                Application Details
              </h3>
              <MembersTable 
                members={appMembers} 
                totalMembers={members.length} 
              />
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2 text-gray-700">
                Ekyc Details
              </h3>
              <MembersTable 
                members={eposMembers} 
                totalMembers={members.length} 
              />
            </div>
          </div>
        ) : (
          <div className="mt-8">
            <h3 className="text-xl font-semibold mb-2 text-gray-700">
              Member Details
            </h3>
            <MembersTable 
              members={members}
              totalMembers={members.length} 
            />
          </div>
        )
      )}

      {members && members.length === 0 && (
        <p className="text-center mt-6 text-red-600 font-medium">
          No Records Found
        </p>
      )}
    </div>
  );
};

export default EkycVerification;
